import HomeIcon from '@mui/icons-material/Home'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import SettingsIcon from '@mui/icons-material/Settings'
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined'

const menuItems = [
  {
    id: 'HM',
    name: 'Inicio',
    to: '/',
    icon: <HomeIcon />,
    subMenus: [],
  },
  {
    id: 'CONFIG',
    name: 'Configuración',
    icon: <SettingsIcon />,
    subMenus: [
      {
        id: 'FRM',
        name: 'Formularios',
        icon: <ReceiptLongIcon />,
        subMenus: [
          {
            id: 'FRMPARAM',
            name: 'Parámetros',
            to: '/frmParams',
            subMenus: [],
          },
          {
            id: 'FRMIMG',
            name: 'Imágenes',
            to: '/frmImg',
            subMenus: [],
          },
          {
            id: 'FRMLEY',
            name: 'Leyendas',
            to: '/frmLeyen',
            subMenus: [],
          },
          {
            id: 'FRMLEYIMG',
            name: 'Leyenda - Logo',
            to: '/frmLeyenImg',
            subMenus: [],
          },
          {
            id: 'FRMLEYFIRM',
            name: 'Leyenda - Firma',
            to: '/frmLeyenFirm',
            subMenus: [],
          },
          {
            id: 'FRMIMGFD',
            name: 'Imagen - Fondo',
            to: '/frmImgFnd',
            subMenus: [],
          },
        ],
      },
      {
        id: 'MSV',
        name: 'Microservicios',
        icon: <AccountTreeOutlinedIcon />,
        subMenus: [
          {
            id: 'MSVPARAMS',
            name: 'Parámetros',
            to: '/msvParams',
            subMenus: [],
          },
          {
            id: 'MSVRUTAREPORTSERVER',
            name: 'Ruta de Report Server',
            to: '/msvRutaReportServer',
            subMenus: [],
          },
          {
            id: 'MSVTABLERODESERVICIOS',
            name: 'Tablero de salud',
            to: '/msvtableroDeServicios',
            subMenus: [],
          },
        ],
      },
    ],
  },
]

const getMenues = () => {
  return new Promise((resolve, reject) => {
    if (menuItems) {
      resolve(menuItems)
    } else {
      reject('No se encontraron item de menú.')
    }
  })
}

export { getMenues }
